<template>
  <v-app>
    <component
      v-if="layout"
      v-bind:is="layout"
    >
      <router-view v-bind:key="viewKey" />
    </component>
    <v-snackbar
      dark
      v-bind="notificationSnackbarAlign"
      v-bind:color="notificationSnackbarColor"
      v-bind:timeout="notificationSnackbarTimeout"
      v-model="notificationSnackbar"
    >
      {{ notificationSnackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          class="snackbar-cross"
          text
          v-bind="attrs"
          v-on:click="onCloseNotificationSnackbar"
        />
      </template>
    </v-snackbar>
    <modal-dialog
      v-bind:title="notificationDialogTitle"
      v-bind:value="notificationDialog"
      v-on:input="onInputNotificationDialog"
      with-cross
    >
      <div class="addiction-contacts">
        <phone-numbers-to-links v-bind:text="notificationDialogText" />
        <div class="addiction-contacts__wrapper-button">
          <whats-mini-button v-bind:link="whatsAppLink" v-if="whatsAppLink" />
          <telegram-mini-button v-bind:link="telegramLink" v-if="telegramLink" />
        </div>
      </div>
    </modal-dialog>
    <axios-error-notifier />
  </v-app>
</template>
<script>
import ClinicPanelLayout from '@/layouts/ClinicPanelLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';
import EntranceLayout from '@/layouts/EntranceLayout.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import PhoneNumbersToLinks from '@/components/PhoneNumbersToLinks.vue';
import TelegramMiniButton from '@/components/TelegramMiniButton.vue';
import WhatsMiniButton from '@/components/WhatsMiniButton.vue';
import notifierMixin, {
  notifierDialogSiteMixin,
  notifierSnackbarSiteMixin,
} from '@/mixins/notifierMixin';
import OnBoardingWindow from '@/components/OnBoardingWindow.vue';
import OnBoardingDialog from '@/components/OnBoardingDialog.vue';
import { VUE_APP_TITLE } from '@/transformEnv';

/**
 * @description Уведомитель об ошибке Axios-клиента.
 * @type {Vue}
 */
const AxiosErrorNotifier = {
  created() {
    const { interceptors } = this.axios;
    interceptors.response.use(undefined, (error) => {
      const { response } = error;
      if (response?.status === 500) {
        this.notifyError('Сервис не доступен. Попробуйте позже.');
      }
      throw error;
    });
  },
  mixins: [notifierMixin],
  render() { return this.$slots.default; },
};

/**
 * @description Компонент приложения.
 */
export default {
  components: {
    OnBoardingDialog,
    OnBoardingWindow,
    WhatsMiniButton,
    TelegramMiniButton,
    AxiosErrorNotifier,
    ClinicPanelLayout,
    EmptyLayout,
    EntranceLayout,
    ModalDialog,
    PhoneNumbersToLinks,
  },
  computed: {
    /**
     * @description Идентификатор компонента-макета.
     * @returns {string}
     */
    layout() {
      return this.$route.meta.layout;
    },
    /**
     * @description Ключ отображаемого раздела.
     * @returns {string}
     */
    viewKey() {
      return this.$route.fullPath;
    },
  },
  metaInfo: { title: VUE_APP_TITLE },
  mixins: [
    notifierDialogSiteMixin,
    notifierSnackbarSiteMixin,
  ],
};
</script>
<style lang="scss">
@use "@/scss/commonScss.scss" as *;

:root {
  --action-color: #0389e0;
  --block-border-radius: 5px;
  --border-color: #c2cfe0;
  --fill-color: #eaeff3;
  --focus-input-color: #003355;
  --input-border-radius: 4px;
  --primary-background-color: #fff;
  --reading-color: #192a3e;
  --section-background-color: #f2f5f8;
  --shadow-layer-bottom: -6px 4px 6px rgba(0, 0, 0, 0.1);
  --shadow-layer-right: -6px 0px 18px rgba(0, 0, 0, 0.06);
  --shadow-layer: 6px 0px 18px rgba(0, 0, 0, 0.06);
  --unfocus-color: #90a0b7;
  --warning-color: red;
  --header-height: 54px;
}

html {
  overflow-y: hidden !important;
}
.addiction-contacts {
  justify-content: left;
  align-items: center;
  width: 100%;
  display: flex;
  gap: 8px 10px;
  flex-wrap: wrap;
  &__wrapper-button {
    display: flex;
    gap: 10px;
  }
}

.snackbar-cross {
  width: 15px;
  height: 15px;
  mask-image: url("@/assets/img/exit-black.svg");
  mask-size: 15px 15px;
  mask-repeat: no-repeat;
  mask-position: center;
  background-color: #ffffff;
}

.container-full {
  min-height: 100%;
}
.v-application p {
  display: flex;
  gap: 5px 10px;
  margin-bottom: 0 !important;
}
@media screen and (max-width: 420px) {
  .v-application p {
    flex-direction: column;
    margin-right: auto;
  }
}
</style>
